/**
 * Families API
 * Handles family CRUD operations and member management
 * Uses centralized apiClient for automatic auth handling
 */

import apiClient from '../utils/apiClient';

/**
 * Fetch all families for current user
 */
export const fetchFamilies = async () => {
    return apiClient.request('/v1/families');
};

/**
 * Fetch single family by ID
 */
export const fetchFamily = async (familyId) => {
    return apiClient.request(`/v1/families/${familyId}`);
};

/**
 * Create new family
 */
export const createFamily = async (familyData) => {
    return apiClient.request('/v1/families', {
        method: 'POST',
        body: JSON.stringify(familyData),
    });
};

/**
 * Update family
 */
export const updateFamily = async (familyId, familyData) => {
    return apiClient.request(`/v1/families/${familyId}`, {
        method: 'PUT',
        body: JSON.stringify(familyData),
    });
};

/**
 * Delete family
 */
export const deleteFamily = async (familyId) => {
    await apiClient.request(`/v1/families/${familyId}`, {
        method: 'DELETE',
    });
    return true;
};

/**
 * Fetch family members
 */
export const fetchFamilyMembers = async (familyId) => {
    return apiClient.request(`/v1/families/${familyId}/members`);
};

/**
 * Add member to family
 */
export const addFamilyMember = async (familyId, memberData) => {
    return apiClient.request(`/v1/families/${familyId}/members`, {
        method: 'POST',
        body: JSON.stringify(memberData),
    });
};

/**
 * Remove member from family
 */
export const removeFamilyMember = async (familyId, userId) => {
    await apiClient.request(`/v1/families/${familyId}/members/${userId}`, {
        method: 'DELETE',
    });
    return true;
};

/**
 * Check if a user exists in the system by email
 */
export const checkUserExists = async (email) => {
    return apiClient.request(`/v1/families/check-user?email=${encodeURIComponent(email)}`);
};

/**
 * Get current user's permissions for a specific family
 */
export const getMyFamilyPermissions = async (familyId) => {
    return apiClient.request(`/v1/families/${familyId}/my-permissions`);
};

